module.exports = __webpack_public_path__ + "img/e7f2eb76f3ce3726d59a624d17e1b99b.6ceb2d39.png";